import { useTranslation } from 'react-i18next'

import { Feedback } from '@features/feedback'

import SEO from '@shared/components/SEO'
import { BRAND_NAME } from '@shared/contants/app'
import Alert from '@shared/ui/alert'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function ContactsPage () {
  const { t: tc } = useTranslation('contacts')
  const { t: ts } = useTranslation('seo')

  return (
    <Container>
      <SEO
        title={ts('contacts.title', { brand: BRAND_NAME })}
        description={ts('contacts.description', { brand: BRAND_NAME })}
      />
      <Wrapper>
        <Breadcrumbs
          className={styles.breadcrumbs}
          links={[
            {
              title: tc('page'),
            },
          ]}
        />

        <div className={styles.container}>
          <div className={styles.content}>
            <h1>Контакты</h1>

            <p>
              Торговая сеть «Dina» - стабильно развивающаяся компания с большими
              возможностями и перспективами в сфере продаж и рекламы. Мы
              доступны для сотрудничества, и предоставляем нашим партнерам
              выгодные предложения взаимодействия на пути достижения общих
              целей.
            </p>

            <Alert className={styles.alert}>
              <img src="/icons/info-square-rounded.svg" alt="" />

              <div>
                <p>
                  {' '}
                  Если Вы хотите стать нашим партнером и развивать Вашу компанию
                  с нашей помощью, либо хотите предложить нам свои условия
                  сотрудничества - просто свяжитесь с нашими менеджерами.{' '}
                </p>

                <p>
                  {' '}
                  Наша компания заинтересована в поиске гибких, индивидуальных и
                  эффективных схем взаимовыгодного партнёрства.
                </p>
              </div>
            </Alert>

            <div className={styles.block}>
              <Feedback />
            </div>
          </div>
        </div>
      </Wrapper>
    </Container>
  )
}
